var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "492px",
    viewBox: "0 0 512 492",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "github") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-3229.000000, -2637.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "github",
    transform: "translate(3229.000000, 2637.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,0.666666667 C114.56,0.666666667 0,113.306667 0,252.229333 C0,363.397333 73.344,457.669333 175.04,490.906667 C187.84,493.274667 192.533333,485.488 192.533333,478.810667 C192.533333,472.837333 192.32,457.008 192.213333,436.037333 C121.002667,451.205333 105.984,402.288 105.984,402.288 C94.336,373.253333 77.504,365.488 77.504,365.488 C54.3146667,349.893333 79.296,350.213333 79.296,350.213333 C105.002667,351.962667 118.506667,376.133333 118.506667,376.133333 C141.333333,414.597333 178.432,403.482667 193.066667,397.061333 C195.370667,380.784 201.962667,369.712 209.28,363.418667 C152.426667,357.125333 92.672,335.493333 92.672,239.109333 C92.672,211.653333 102.592,189.210667 119.018667,171.610667 C116.138667,165.253333 107.498667,139.674667 121.258667,105.029333 C121.258667,105.029333 142.698667,98.288 191.658667,130.821333 C212.138667,125.232 233.898667,122.458667 255.658667,122.330667 C277.418667,122.458667 299.178667,125.232 319.658667,130.821333 C368.298667,98.288 389.738667,105.029333 389.738667,105.029333 C403.498667,139.674667 394.858667,165.253333 392.298667,171.610667 C408.618667,189.210667 418.538667,211.653333 418.538667,239.109333 C418.538667,335.749333 358.698667,357.018667 301.738667,363.205333 C310.698667,370.757333 319.018667,386.181333 319.018667,409.754667 C319.018667,443.418667 318.698667,470.469333 318.698667,478.64 C318.698667,485.232 323.178667,493.104 336.298667,490.586667 C438.72,457.562667 512,363.226667 512,252.229333 C512,113.306667 397.376,0.666666667 256,0.666666667 L256,0.666666667 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.ed1509a0dce7d0e70e7ae32727fbd360.svg";
export { ForwardRef as ReactComponent };